function waitForCustomerReferralLoaded(a, b = 100) {
  const c = setInterval(function () {
    "undefined" != typeof uppromoteCustomerReferral && (a(), clearInterval(c));
  }, b);
  setTimeout(function () {
    clearInterval(c);
  }, 5e3);
}
function waitElementLoaded(a, b, c = 100) {
  const d = setInterval(function () {
    const c = document.querySelector(a);
    c && (b(), clearInterval(d));
  }, c);
  setTimeout(function () {
    clearInterval(d);
  }, 5e3);
}

const customerReferralItemSelector = `div[class="sca_aff_customer_refer_container"]`;

waitForCustomerReferralLoaded(function () {
  waitElementLoaded(customerReferralItemSelector, function () {
    let elements = document.getElementsByClassName("sca_aff_customer_refer_invite_content");

    for (let i = 0; i < elements.length; i++) {
      elements[i].style.marginTop = '15px';
    }
  });
});